module.exports = __webpack_public_path__ + "img/fencing.8427854f.svg";